import { NgFor, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';

@Component({
    selector: 'uib-dropdown',
    template: `<mat-form-field [style.width]="'100%'">
		<mat-label *ngIf="to.label">{{ to.label }}</mat-label>
		<mat-select placeholder="{{ to.label }}" [(value)]="value" (closed)="blur()">
			<div class="dropdownItems">
				<input type="text" [(ngModel)]="searchValue" (ngModelChange)="updateSearchValue()" />
			</div>
			<ng-container>
				<mat-option *ngFor="let option of filteredSelectOptions" [value]="option.value" (click)="handleSelection(option, $event)">
					{{ option.label }}
				</mat-option>
			</ng-container>
		</mat-select>
	</mat-form-field>`,
    standalone: true,
    imports: [
        MatFormFieldModule,
        NgIf,
        MatSelectModule,
        FormsModule,
        NgFor,
        MatOptionModule,
    ],
})
export class UibDropdownComponent extends FieldType<FormlyFieldConfig> implements OnInit {
	searchValue = '';
	selectOptions = [];
	filteredSelectOptions = [];
	selectedValue = { value: 0, label: 'ALL' };
	constructor() {
		super();
	}
	ngOnInit() {
		this.selectOptions = this.props.selects ?? [];
		this.filteredSelectOptions = [...this.selectOptions];
		if (this.value === 0 || this.value == null) {
			this.value = 0;
			this.selectedValue = { value: 0, label: 'ALL' };
		} else {
			this.selectedValue = { value: this.value, label: this.filteredSelectOptions.find((select) => select.value === this.value).label };
		}
		this.searchValue = '';
	}

	updateSearchValue() {
		this.filteredSelectOptions = this.selectOptions.filter(
			(option) => option.label.toLowerCase().includes(this.searchValue.toLowerCase()) || option.value === 0
		);
	}

	handleSelection(value, event) {
		this.selectedValue = value;
		if (this.props.change) {
			this.props.change(this.field, event);
		}
	}

	blur() {
		if (!this.filteredSelectOptions.some((y) => y.value === this.selectedValue.value)) {
			this.filteredSelectOptions.push(this.selectOptions.find((x) => x.value === this.selectedValue.value));
		}
		this.value = this.selectedValue.value;
	}
}
